import axios from "axios";

const searchByCustomerName = async (name) => {

    const response = await axios.get(`/sell/search-by-customer/${name}`);
    return response.data;
}

const getAllSellings = async () => {
    const response = await axios.get(`/sell/`);
    return response.data;
}
export {
    searchByCustomerName,
    getAllSellings
};